const actions = {
  SINGLE_RECHARGE: "SINGLE_RECHARGE",
  SINGLE_RECHARGE_SUCCESS: "SINGLE_RECHARGE_SUCCESS",
  SINGLE_RECHARGE_FAILED: "SINGLE_RECHARGE_FAILED",

  BULK_RECHARGE: "BULK_RECHARGE",
  BULK_RECHARGE_SUCCESS: "BULK_RECHARGE_SUCCESS",
  BULK_RECHARGE_FAILED: "BULK_RECHARGE_FAILED",


  RESET_MESSAGE: "RESET_MESSAGE",

  singleRechargeReq: (data) => ({
    type: actions.SINGLE_RECHARGE,
    payload: { data },
  }),
  singleRechargeSuccess: (message) => ({
    type: actions.SINGLE_RECHARGE_SUCCESS,
    payload: { message }
  }),
  singleRechargeFailed: (error) => ({
    type: actions.SINGLE_RECHARGE_FAILED,
    payload: { error },
  }),

  bulkRechargeReq: (data) => ({
    type: actions.BULK_RECHARGE,
    payload: { data },
  }),
  bulkRechargeSuccess: (message) => ({
    type: actions.BULK_RECHARGE_SUCCESS,
    payload: { message }
  }),
  bulkRechargeFailed: (error, fdata) => ({
    type: actions.BULK_RECHARGE_FAILED,
    payload: { error, fdata },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),


}

export default actions;